<template>
  <div style="height:100%;width:100%">

    <div class="col-12" style="text-align: center;padding: 0px;" id="reminders">
      <h5 style="padding-top: 1em;" v-if="remindersToSet('morning').length == 0 && remindersToSet('afternoon').length == 0 && remindersToSet('evening').length == 0 && remindersToSet('night').length == 0">{{$t("message.No medications found!")}}</h5>
      <div v-else style="margin-top: 1em;height: 82vh;overflow: scroll;">
        <div style="display: flex; padding: 15px;gap: 10px;">
          <i class="fas fa-sync-alt" style="display: inline-block;margin-inline-start: 0.5em;color: black;font-size: 1.2em;"></i>
          <h6 style="display: inline-block;margin-inline-start: 0.5em;color: black;font-size: 1.2em;">{{startDate }}</h6>
          <h6>-</h6>
          <h6 style="display: inline-block;color: black;font-size: 1.2em;">{{endDate }}</h6>
          <h6 style="display: inline-block;color: black;font-size: 1.2em;"> &#40; {{totalDays }} Days &#41;</h6>
        </div>
        <card style="width: 95%;margin: 0.7em;text-align: start;" class="rounded" v-if="remindersToSet('morning').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-inline-start: 0.5em;color: black;font-size: 1.2em;">{{$t('message.Morning')}}</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in remindersToSet('morning')" :key="reminder.id" class="col-12" style="padding: 0px;display: flex;align-items: center;" :style="remindersToSet('morning').length > 0  && index < remindersToSet('morning').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-inline-end: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-inline-start: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-9" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>
            <div class="col-1" style="color: var(--color-primary);">
              <i class="fas fa-trash" @click="removeReminder(reminder)"></i>
            </div>
          </div>
        </card>

        <card style="width: 95%;margin: 0.7em;text-align: start;" class="rounded" v-if="remindersToSet('afternoon').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-inline-start: 0.5em;color: black;font-size: 1.2em;">{{$t('message.Afternoon')}}</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in remindersToSet('afternoon')" :key="reminder.id" class="col-12;" style="padding: 0px;display: flex;align-items: center;" :style="remindersToSet('afternoon').length > 0  && index < remindersToSet('afternoon').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-inline-end: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-inline-start: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-9" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>
            <div class="col-1" style="color: var(--color-primary);">
              <i class="fas fa-trash" @click="removeReminder(reminder)"></i>
            </div>
          </div>
        </card>

        <card style="width: 95%;margin: 0.7em;text-align: start;" class="rounded" v-if="remindersToSet('evening').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-inline-start: 0.5em;color: black;font-size: 1.2em;">{{$t('message.Evening')}}</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in remindersToSet('evening')" :key="reminder.id" class="col-12;" style="padding: 0px;display: flex;align-items: center;" :style="remindersToSet('evening').length > 0  && index < remindersToSet('evening').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-inline-end: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-inline-start: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-9" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>
            <div class="col-1" style="color: var(--color-primary);">
              <i class="fas fa-trash" @click="removeReminder(reminder)"></i>
            </div>
          </div>
        </card>

        <card style="width: 95%;margin: 0.7em;text-align: start;" class="rounded" v-if="remindersToSet('night').length > 0">
          <div class="col-12" style="padding: 0px;">
            <label>
              <h6 style="display: inline-block;margin-inline-start: 0.5em;color: black;font-size: 1.2em;">{{$t('message.Night')}}</h6>
            </label>
          </div>
          <div v-for="(reminder,index) in remindersToSet('night')" :key="reminder.id" class="col-12;" style="padding: 0px;display: flex;align-items: center;" :style="remindersToSet('night').length > 0  && index < remindersToSet('night').length-1 ? 'border-bottom: 0.1px solid rgb(154, 154, 154);' :''">
            <div class="col-2" style="padding: 0px;">
              <div style="width: 4em;margin-inline-end: 1em;">
                <i style="font-size: 2.6em;color: rgb(154, 154, 154);padding: 0.2em;padding-inline-start: 0px;" class="fas" :class="getClassName(reminder.text)"></i>
              </div>
            </div>
            <div class="col-9" style="padding: 0px;">
              <div style="padding: 0px;display: flex;justify-content:start;text-align: start;font-size: 0.9em;">
                <span>{{reminder.text}} <span v-if="reminder && reminder.trigger && reminder.trigger.at" style="font-weight: 600;">({{new Date(reminder.trigger.at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}})</span></span>
              </div>
            </div>
            <div class="col-1" style="color: var(--color-primary);">
              <i class="fas fa-trash" @click="removeReminder(reminder)"></i>
            </div>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showTimeModel" headerclasses="justify-content-center" class="time-action-modal" footerClasses="justify-content-center" modalContentClasses="time-action-modal-content" :showClose="false" :animationDuration="250">
      <h5 slot="header" class="title title-up">
        {{$t('message.Select Time')}}
      </h5>
      <div style="width: 100%;height: 32vh;overflow: scroll;padding: 0 0.5em;overflow-x: hidden;" id="prescriptions-modal">
        <div class="col-12" style="width: 100;overflow: scroll;padding:0px;">
          <div class="col-6" style="padding: 0px;    display: inline-block;" v-if="remindersToSet('morning').length > 0">
            <label style=" font-weight: 600;">{{$t('message.Morning')}}</label>
            <vue-datetime v-model="morningTime" type="time" format="hh:mm a" :placeholder="$t('message.Select Date and Time')" :minute-step="10" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control"></vue-datetime>
          </div>
          <div class="col-6" style="padding: 0px;    display: inline-block;" v-if="remindersToSet('afternoon').length > 0">
            <label style=" font-weight: 600;">{{$t('message.Afternoon')}}</label>
            <vue-datetime v-model="afternoonTime" type="time" format="hh:mm a" :placeholder="$t('message.Select Date and Time')" :minute-step="10" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control"></vue-datetime>
          </div>
          <div class="col-6" style="padding: 0px; display: inline-block;" v-if="remindersToSet('evening').length > 0">
            <label style=" font-weight: 600;">{{$t('message.Evening')}}</label>
            <vue-datetime v-model="eveningTime" type="time" format="hh:mm a" :placeholder="$t('message.Select Date and Time')" :minute-step="10" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control"></vue-datetime>
          </div>
          <div class="col-6" style="padding: 0px;    display: inline-block;" v-if="remindersToSet('night').length > 0">
            <label style=" font-weight: 600;">{{$t('message.Night')}}</label>
            <vue-datetime v-model="nightTime" type="time" format="hh:mm a" :placeholder="$t('message.Select Date and Time')" :minute-step="10" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control"></vue-datetime>
          </div>
        </div>
        <div class="col-12">
          <p>{{$t('message.Notifications will be sent at this time')}}</p>
        </div>
        <div class="col-12" style="padding: 0px;text-align:center">
          <n-button type="primary" round size="sm" @click.native="set()">
            {{$t('message.Set')}}
          </n-button>
        </div>
      </div>
    </modal>

    <div class="col-12" style="text-align:center;position: fixed;bottom: 1em;">
      <n-button type="primary" size="sm" round @click.native="showTimeModel=true">
        <i class="fa fa-plus"></i>
        {{$t('message.Set Reminders')}}
      </n-button>
    </div>

  </div>
</template>


<script>
import moment from "moment";
export default {
  data() {
    return {
      frequencyNoOfDays: 0,
      notifications: [],
      showTimeModel: false,
      morningTime: new Date(new Date().setHours(9, 0, 0, 0)).toISOString(),
      afternoonTime: new Date(new Date().setHours(13, 0, 0, 0)).toISOString(),
      eveningTime: new Date(new Date().setHours(18, 0, 0, 0)).toISOString(),
      nightTime: new Date(new Date().setHours(21, 0, 0, 0)).toISOString(),
    };
  },
  async mounted() {
    this.addNotifications(this.selectedPrescription);
  },
  methods: {
    set() {
      for (let notification of this.notifications) {
        console.log("this.notifications", this.notifications);
        if (notification.title == "Morning medication") {
          notification.trigger.at = new Date(notification.trigger.at).setHours(
            new Date(this.morningTime).getHours(),
            new Date(this.morningTime).getMinutes(),
            new Date(this.morningTime).getSeconds()
          );
        } else if (notification.title == "Afternoon medication") {
          notification.trigger.at = new Date(notification.trigger.at).setHours(
            new Date(this.afternoonTime).getHours(),
            new Date(this.afternoonTime).getMinutes(),
            new Date(this.afternoonTime).getSeconds()
          );
        } else if (notification.title == "Evening medication") {
          notification.trigger.at = new Date(notification.trigger.at).setHours(
            new Date(this.eveningTime).getHours(),
            new Date(this.eveningTime).getMinutes(),
            new Date(this.eveningTime).getSeconds()
          );
        } else if (notification.title == "Night medication") {
          notification.trigger.at = new Date(notification.trigger.at).setHours(
            new Date(this.nightTime).getHours(),
            new Date(this.nightTime).getMinutes(),
            new Date(this.nightTime).getSeconds()
          );
        }
      }
      if (this.notifications.length > 0) {
        //schedule medication local notifications
        cordova.plugins.notification.local.schedule(this.notifications, () => {
          swal.fire({
            title: "Reminders added!",
            type: "success",
          });
          this.$router.push("/reminders");
        });
      } else {
        swal.fire({
          title: this.$t("message.No medications found!"),
          type: "info",
        });
      }
    },
    removeReminder(reminder) {
      swal
        .fire({
          title: "Are you sure that you want to remove this reminder?",
          confirmButtonText: "yes",
          showCancelButton: true,
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result && result.value) {
            let notifications = [];
            for (let notification of this.notifications) {
              if (
                notification.title == reminder.title &&
                notification.text == reminder.text
              ) {
                continue;
              } else {
                notifications.push(notification);
              }
            }
            this.notifications = notifications;
            swal.fire({
              title: "Reminder removed!",
              type: "success",
            });
          }
        });
    },
    getClassName(text) {
      try {
        if (text.split(",")[1].includes("TABLET")) {
          return "fa-tablets";
        } else if (text.split(",")[1].includes("CAPSULE")) {
          return "fa-capsules";
        } else if (text.split(",")[1].includes("INJECTION")) {
          return "fa-syringe";
        } else if (text.split(",")[1].includes("SOLUTION")) {
          return "fa-flask";
        } else if (text.split(",")[1].includes("POWDER")) {
          return "fa-prescription-bottle";
        } else if (text.split(",")[1].includes("SYRUP")) {
          return "fa-fill-drip";
        } else if (text.split(",")[1].includes("PILL")) {
          return "fa-pills";
        } else if (text.split(",")[1].includes("LOTION")) {
          return "fa-tint";
        } else if (text.split(",")[1].includes("GEL")) {
          return "fa-tint";
        } else if (text.split(",")[1].includes("CREAM")) {
          return "fa-tint";
        } else if (text.split(",")[1].includes("DROPS")) {
          return "fa-eye-dropper";
        } else {
          return "fa-prescription-bottle-alt";
        }
      } catch {
        return "fa-prescription-bottle-alt";
      }
    },
    remindersToSet(time) {
      if (this.notifications && this.notifications.length > 0) {
        // filter notification for today
        let remindersToSet = this.notifications.filter(function (reminder) {
          return (
            new Date(reminder.trigger.at).setHours(0, 0, 0, 0) ==
              new Date().setHours(0, 0, 0, 0).valueOf() &&
            reminder.title.split(" ")[0].toLowerCase() == time
          );
        });

        // filter for next day
        let remindersToSetNext = this.notifications.filter(function (reminder) {
          return reminder.title.split(" ")[0].toLowerCase() == time;
        });

        return remindersToSet.length > 0 ? remindersToSet : remindersToSetNext;
      }
      return [];
    },
    addNotifications(prescription) {
      this.notifications = [];
      if (prescription && prescription.prescriptions) {
        for (let _prescription of prescription.prescriptions) {
          if (_prescription.prescriptions && _prescription.prescriptions.rx) {
            let id = 0;
            if (localStorage.remindersId) {
              id = Number(localStorage.remindersId);
            }
            for (let rx of _prescription.prescriptions.rx) {
              let notificationForEachRx = [];
              let noOfDays = 1;
              let createdDate = new Date().setHours(0, 0, 0, 0);
              let increment = 1;
              if (
                rx.frequency &&
                rx.frequency.duration &&
                rx.frequency.durationNo
              ) {
                if (!rx.frequency.duration) {
                  rx.frequency.duration = "Days";
                }
                if (rx.frequency.duration == "Days") {
                  noOfDays = Number(rx.frequency.durationNo);
                } else if (rx.frequency.duration == "Week") {
                  noOfDays = Number(rx.frequency.durationNo) * 7;
                } else if (rx.frequency.duration == "Months") {
                  noOfDays = Number(rx.frequency.durationNo) * 30;
                }
              }

              if (
                rx.frequency &&
                rx.frequency.day &&
                rx.frequency.day == "Alternate days"
              ) {
                noOfDays = noOfDays * 2;
                increment = 2;
              }
              this.frequencyNoOfDays = noOfDays;

              if (
                rx.frequency &&
                rx.frequency.morning &&
                rx.frequency.morning.nos &&
                rx.frequency.morning.nos > 0
              ) {
                for (let i = 0; i < noOfDays; i = i + increment) {
                  let date = new Date(createdDate).setHours(9, 0, 0, 0);
                  date = new Date(date);
                  date.setDate(date.getDate() + i);
                  notificationForEachRx.push({
                    title: `Morning medication`,
                    text: `${rx.name}, ${rx.frequency.morning.nos} ${rx.dosageName}`,
                    trigger: {
                      at: date,
                    },
                    id: id,
                    foreground: true,
                    autoClear: false,
                    data: "medication notification",
                  });
                  id++;
                }
              }

              if (
                rx.frequency &&
                rx.frequency.afternoon &&
                rx.frequency.afternoon.nos &&
                rx.frequency.afternoon.nos > 0
              ) {
                for (let i = 0; i < noOfDays; i = i + increment) {
                  let date = new Date(createdDate).setHours(13, 0, 0, 0);
                  date = new Date(date);
                  date.setDate(date.getDate() + i);
                  notificationForEachRx.push({
                    title: `Afternoon medication`,
                    text: `${rx.name}, ${rx.frequency.afternoon.nos} ${rx.dosageName}`,
                    trigger: {
                      at: date,
                    },
                    id: id,
                    foreground: true,
                    autoClear: false,
                    data: "medication notification",
                  });
                  id++;
                }
              }

              if (
                rx.frequency &&
                rx.frequency.evening &&
                rx.frequency.evening.nos &&
                rx.frequency.evening.nos > 0
              ) {
                for (let i = 0; i < noOfDays; i = i + increment) {
                  let date = new Date(createdDate).setHours(18, 0, 0, 0);
                  date = new Date(date);
                  date.setDate(date.getDate() + i);
                  notificationForEachRx.push({
                    title: `Evening medication`,
                    text: `${rx.name}, ${rx.frequency.evening.nos} ${rx.dosageName}`,
                    trigger: {
                      at: date,
                    },
                    id: id,
                    foreground: true,
                    autoClear: false,
                    data: "medication notification",
                  });
                  id++;
                }
              }

              if (
                rx.frequency &&
                rx.frequency.night &&
                rx.frequency.night.nos &&
                rx.frequency.night.nos > 0
              ) {
                for (let i = 0; i < noOfDays; i = i + increment) {
                  let date = new Date(createdDate).setHours(21, 0, 0, 0);
                  date = new Date(date);
                  date.setDate(date.getDate() + i);
                  notificationForEachRx.push({
                    title: `Night medication`,
                    text: `${rx.name}, ${rx.frequency.night.nos} ${rx.dosageName}`,
                    trigger: {
                      at: date,
                    },
                    id: id,
                    foreground: true,
                    autoClear: false,
                    data: "medication notification",
                  });
                  id++;
                }
              }

              // if no frequency is given then set reminder for one day

              localStorage.remindersId = id;
              console.log(rx);

              this.notifications = this.notifications.concat(
                notificationForEachRx
              );
            }

            // commenting this feature because of complexity the prescription which don't have frequency
            //   for (let rx of _prescription.prescriptions.rx) {

            //   let notificationForEachRx = this.notifications.filter((item) => {
            //     return item.text.includes(rx.name);
            //   });

            //   //Check if notification for this RX was pushed. Which means it has frequency prescribed
            //   if (notificationForEachRx.length === 0) {

            //     let createdDate = new Date().setHours(0, 0, 0, 0);
            //     const currentTime = moment();
            //     const time9AM = moment().set({ hour: 9, minute: 0, second: 0 });
            //     const time1PM = moment().set({ hour: 13, minute: 0, second: 0 });
            //     const time6PM = moment().set({ hour: 18, minute: 0, second: 0 });
            //     const time9PM = moment().set({ hour: 21, minute: 0, second: 0 });
            //     let date = new Date(createdDate);

            //     if (currentTime.isAfter(time9AM)) {
            //       if (currentTime.isAfter(time1PM)) {
            //         if (currentTime.isAfter(time6PM)) {
            //           if (currentTime.isAfter(time9PM)) {
            //             date = new Date(createdDate).setHours(9, 0, 0, 0);
            //             date = new Date(date);
            //             date.setDate(date.getDate() + 1);
            //             notificationForEachRx.push({
            //               title: `Morning medication`,
            //               text: `${rx.name}, ${rx.frequency.night.nos} ${rx.dosageName}`,
            //               trigger: {
            //                 at: date,
            //               },
            //               id: id,
            //               foreground: true,
            //               autoClear: false,
            //               data: "medication notification",
            //             });

            //           } else {
            //             date = new Date(createdDate).setHours(21, 0, 0, 0);
            //             date = new Date(date);
            //             date.setDate(date.getDate());
            //             notificationForEachRx.push({
            //               title: `Night medication`,
            //               text: `${rx.name}, ${rx.frequency.night.nos} ${rx.dosageName}`,
            //               trigger: {
            //                 at: date,
            //               },
            //               id: id,
            //               foreground: true,
            //               autoClear: false,
            //               data: "medication notification",
            //             });
            //           }

            //         } else {
            //           date = new Date(createdDate).setHours(18, 0, 0, 0);
            //           date = new Date(date);
            //           date.setDate(date.getDate());
            //           notificationForEachRx.push({
            //             title: `Evening medication`,
            //             text: `${rx.name}, ${rx.frequency.night.nos} ${rx.dosageName}`,
            //             trigger: {
            //               at: date,
            //             },
            //             id: id,
            //             foreground: true,
            //             autoClear: false,
            //             data: "medication notification",
            //           });
            //         }

            //       } else {
            //         date = new Date(createdDate).setHours(13, 0, 0, 0);
            //         date = new Date(date);
            //         date.setDate(date.getDate());
            //         notificationForEachRx.push({
            //           title: `Afternoon medication`,
            //           text: `${rx.name}, ${rx.frequency.night.nos} ${rx.dosageName}`,
            //           trigger: {
            //             at: date,
            //           },
            //           id: id,
            //           foreground: true,
            //           autoClear: false,
            //           data: "medication notification",
            //         });
            //       }
            //     } else {
            //       date = new Date(createdDate).setHours(9, 0, 0, 0);
            //       date = new Date(date);
            //       date.setDate(date.getDate());
            //       notificationForEachRx.push({
            //         title: `Morning medication`,
            //         text: `${rx.name}, ${rx.frequency.night.nos} ${rx.dosageName}`,
            //         trigger: {
            //           at: date,
            //         },
            //         id: id,
            //         foreground: true,
            //         autoClear: false,
            //         data: "medication notification",
            //       });
            //     }
            //     this.notifications = this.notifications.concat(notificationForEachRx);
            //   }

            //   id++;

            // }
          }
        }
      }
    },
  },
  computed: {
    selectedPrescription() {
      return this.$store.state.selectedPrescription;
    },
    startDate() {
      if (this.notifications && this.notifications.length > 0) {
        return moment(this.notifications[0].trigger.at).format("MMM DD");
      }
    },
    endDate() {
      if (this.notifications && this.notifications.length > 0) {
        let arrayLength = this.notifications.length;
        return moment(this.notifications[arrayLength - 1].trigger.at).format(
          "MMM DD"
        );
      }
    },
    totalDays() {
      return this.frequencyNoOfDays;
    },
  },
};
</script>

<style scoped>
/deep/.time-action-modal:not(.d-none) {
  display: flex !important;
  align-items: end;
}
/deep/.time-action-modal .modal-dialog {
  width: 100%;
  margin: 0;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
  overflow: hidden;
}
</style>
